import { render } from "./tipModal.vue?vue&type=template&id=491f50ae&scoped=true"
import script from "./tipModal.vue?vue&type=script&lang=js"
export * from "./tipModal.vue?vue&type=script&lang=js"

import "./tipModal.vue?vue&type=style&index=0&id=491f50ae&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-491f50ae"]])

export default __exports__